import React, { ErrorInfo, ReactNode } from 'react'
import logoLight from '@/assets/logo/olimhub-logo.png'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

function DefaultErrorFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '48px 24px',
        textAlign: 'center',
      }}
    >
      <img src={logoLight} alt="OlimHub" style={{ height: 32, marginBottom: 24, opacity: 0.65 }} />
      <h2
        style={{
          margin: '0 0 8px',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--fs-body-lg)',
          fontWeight: 600,
          color: 'var(--text-strong)',
        }}
      >
        Something went wrong
      </h2>
      <p
        style={{
          margin: '0 0 24px',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--fs-sm)',
          color: 'var(--text-muted)',
          maxWidth: 280,
          lineHeight: 'var(--lh-normal)',
        }}
      >
        We're sorry — please refresh the page
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 24px',
          borderRadius: 'var(--radius-pill)',
          border: 'none',
          background: 'var(--brand)',
          color: 'var(--on-brand)',
          fontFamily: 'var(--font-sans)',
          fontWeight: 600,
          fontSize: 'var(--fs-sm)',
          cursor: 'pointer',
        }}
      >
        Refresh page
      </button>
    </div>
  )
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info)
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <DefaultErrorFallback />
    }
    return this.props.children
  }
}
